<template>
  <div class="brand-panel">
    <div class="brand-panel__sky" aria-hidden="true">
      <span class="brand-panel__glow"></span>
      <span class="brand-panel__orbit brand-panel__orbit--1"></span>
      <span class="brand-panel__orbit brand-panel__orbit--2"></span>
      <span
        v-for="(star, s) in stars"
        :key="s"
        class="brand-panel__star"
        :style="{
          top: star.top + '%',
          left: star.left + '%',
          width: star.size + 'px',
          height: star.size + 'px',
          opacity: star.op,
          animationDelay: star.delay + 's',
        }"
      ></span>
    </div>

    <div class="brand-panel__content">
      <div class="brand-panel__brand">
        <v-avatar size="44" class="brand-panel__logo">
          <img src="@/assets/images/logo.svg" alt="Jackocoins" />
        </v-avatar>
        <span class="brand-panel__name">Jackocoins</span>
      </div>

      <h1 class="brand-panel__title">
        Trade with<br />
        <span class="brand-panel__grad">velocity</span>
        <v-icon class="brand-panel__rocket" color="#ff7a59">mdi-rocket</v-icon>
      </h1>
      <p class="brand-panel__text">
        The easiest and most trusted place to buy, sell and swap your crypto
        &mdash; fast payouts, fair rates and bank-grade security.
      </p>

      <div class="brand-panel__trust">
        <span class="brand-panel__chip">
          <v-icon size="16" color="#7eb0ff" class="mr-1">mdi-flash</v-icon>
          Instant payouts
        </span>
        <span class="brand-panel__chip">
          <v-icon size="16" color="#7eb0ff" class="mr-1"
            >mdi-scale-balance</v-icon
          >
          Fair rates
        </span>
        <span class="brand-panel__chip">
          <v-icon size="16" color="#7eb0ff" class="mr-1"
            >mdi-shield-check</v-icon
          >
          Bank-grade security
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "AuthBrandPanel",
  computed: {
    stars() {
      const out = [];
      for (let i = 0; i < 32; i++) {
        out.push({
          top: ((i * 41) % 90) + 3,
          left: ((i * 59) % 94) + 3,
          size: 1.5 + (i % 3),
          op: 0.25 + (i % 4) * 0.2,
          delay: (i % 6) * 0.5,
        });
      }
      return out;
    },
  },
});
</script>

<style scoped>
.brand-panel {
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: radial-gradient(
    120% 130% at 80% 0%,
    #1e6bff 0%,
    #0a3aa8 36%,
    #06205f 70%,
    #04143d 100%
  );
}
.brand-panel__sky {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.brand-panel__glow {
  position: absolute;
  width: 560px;
  height: 560px;
  top: -260px;
  right: -120px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(94, 154, 255, 0.5) 0%,
    rgba(94, 154, 255, 0) 70%
  );
  filter: blur(20px);
}
.brand-panel__orbit {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 50%;
}
.brand-panel__orbit--1 {
  width: 460px;
  height: 460px;
  top: -150px;
  right: -80px;
}
.brand-panel__orbit--2 {
  width: 720px;
  height: 720px;
  top: -260px;
  right: -200px;
}
.brand-panel__star {
  position: absolute;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.7);
  animation: bp-twinkle 3.2s ease-in-out infinite;
}
@keyframes bp-twinkle {
  0%,
  100% {
    opacity: 0.2;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.brand-panel__content {
  position: relative;
  z-index: 1;
  padding: 0 12% 0 14%;
  max-width: 560px;
}
.brand-panel__brand {
  display: flex;
  align-items: center;
  margin-bottom: 48px;
}
.brand-panel__logo {
  filter: brightness(0) invert(1);
}
.brand-panel__name {
  margin-left: 12px;
  font-size: 1.5rem;
  font-weight: 800;
  color: #fff;
}
.brand-panel__title {
  font-size: 3.2rem;
  line-height: 1.08;
  letter-spacing: -0.02em;
  font-weight: 800;
  color: #fff;
}
.brand-panel__grad {
  background: linear-gradient(90deg, #9bc4ff 0%, #ffffff 65%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.brand-panel__rocket {
  font-size: 40px !important;
  vertical-align: middle;
  margin-left: 10px;
  transform: rotate(8deg);
}
.brand-panel__text {
  margin-top: 22px;
  font-size: 1.1rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.78);
}
.brand-panel__trust {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 22px;
  margin-top: 36px;
}
.brand-panel__chip {
  display: inline-flex;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
}
@media (prefers-reduced-motion: reduce) {
  .brand-panel__star {
    animation: none !important;
  }
}
</style>
